import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CompanyProfileService } from './services/company-profile.service';
import { CompanyProfile } from './interfaces/company-profile';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-company-profile',
  templateUrl: './company-profile.component.html',
  styleUrls: ['./company-profile.component.css'],
})
export class CompanyProfileComponent implements OnInit {
  activeTab: string = 'overview';
  companyProfile: CompanyProfile | null = null;
  isLoading: boolean = true;
  companyId: string = ''; 
  

  constructor(
    private companyProfileService: CompanyProfileService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
  
    const idFromRoute = this.route.snapshot.paramMap.get('id');
    if (idFromRoute) {
      this.companyId = idFromRoute;
    }
    this.loadCompanyProfile();
  }
 getCoverUrl(): string {
    return this.companyProfile?.coverUrl
      ? environment.apiImagePath + this.companyProfile.coverUrl
      : '../../../assets/img/company/compnay-header.jpg';
  }
  loadCompanyProfile(): void {
    this.isLoading = true;
    this.companyProfileService.getCompanyProfile(this.companyId).subscribe({
      next: (data) => {
        this.companyProfile = data;
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error loading company profile:', err);
        this.isLoading = false;
      }
    });
  }

  setActiveTab(tab: string): void {
    this.activeTab = tab;
  }

  getStarsArray(rate: number): string[] {
    const stars: string[] = [];
    const fullStars = Math.floor(rate);
    const hasHalf = rate % 1 >= 0.5;
    for (let i = 0; i < 5; i++) {
      if (i < fullStars) {
        stars.push('bi-star-fill');
      } else if (i === fullStars && hasHalf) {
        stars.push('bi-star-half');
      } else {
        stars.push('bi-star');
      }
    }
    return stars;
  }
}